module.exports = __webpack_public_path__ + "static/media/ico-twitter.5bff8270.svg";